import React from 'react';
import { Grid, CircularProgress, Typography } from '@material-ui/core';

type NetworkIndicatorProps = {
  /** The network message to display */
  message: string;
  /** If false, nothing will be rendered */
  requesting: boolean;
  /** Which variant to use */
  variant?: 'vertical' | 'horizontal';
};

const NetworkIndicator = ({
  message,
  requesting,
  variant = 'vertical',
}: NetworkIndicatorProps): JSX.Element =>
  requesting ? (
    <Grid
      item
      xs={12}
      container
      justifyContent={variant === 'vertical' ? 'center' : 'flex-start'}
      alignItems={variant === 'vertical' ? 'flex-start' : 'center'}
      style={{
        minHeight: variant === 'vertical' ? 56 : 'auto',
      }}
    >
      {variant === 'vertical' ? (
        <span
          data-testid="wrapper-span"
          style={{ textAlign: 'center', paddingTop: 16 }}
        >
          <CircularProgress />
          <br />
          <br />
          <Typography variant="caption">{message}</Typography>
        </span>
      ) : (
        <>
          <CircularProgress size={24} style={{ marginRight: '1em' }} />
          <Typography variant="caption">{message}</Typography>
        </>
      )}
    </Grid>
  ) : (
    <div />
  );

export default NetworkIndicator;
